import { replacePLChars, ReplacePlCharsSize } from './string-tools';

export default function generateElementId(str: string): string {
    return replacePLChars(str.toLowerCase(), ReplacePlCharsSize.Lowercase).replace(/\s+/g, '_');
}
